module.exports = "/images/mara.webp?007c879479cfa18e16b395b75dc99e00";